import React from 'react';
import LearnMoreLink from '../../../Common/LearnMoreLink/LearnMoreLink';
import { linkTypes } from '../../../../models/Models';


export const LearnMoreButton = ({ data, className }) => {

	if (data == null || !data.HasLink) {
		return null;
	}

	const external = data.Type === linkTypes.EXTERNAL;
	return <LearnMoreLink
		className={className}
		text={data.Text}
		altText={data.altText}
		external={external}
		to={
			external ?
				data.ExternalURL.Text :
				`/${data.InternalURL.BasePath && data.InternalURL.BasePath.Text}/${
					data.InternalURL.Path && data.InternalURL.Path.Path
				}`
		}
	/>;
};